import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { Badge } from '~/ui-apps/design-system/atoms/Badge';

const PasswordlessAuthCallout: React.FC = () => (
  <div className="flex justify-center">
    <Badge
      variant="outline"
      className="border-green-100 bg-green-50 text-green-700 font-normal"
    >
      <FontAwesomeIcon icon={faLock} aria-hidden="true" />
      Passwordless • Secure • Email-based login
    </Badge>
  </div>
);

export default PasswordlessAuthCallout;
